<template>
  <section class="latest">
    <div class="inner">
      <div class="header">Current Sites</div>
      <slide-show>
        <div class="slide">
          <div class="grid">
            <page-link :key="property.ItemID" :to="'/p/' + property.ItemID" v-for="property in latest">
              <span
                :style="{ backgroundImage: 'url(' + property.images[0].image + ')' }"
                class="image"
                title="Name"
                v-if="property.images && property.images.length"
              ></span>
              <span class="info">
                <span class="name">{{ property.street }}, {{ property.area }}</span>
                <span class="date">{{ property.key_features }}</span>
              </span>
            </page-link>
          </div>
        </div>
      </slide-show>
      <!-- <div class="controls">
        <a class="next" href><font-awesome-icon icon="chevron-right"/></a>
        <a class="prev" href><font-awesome-icon icon="chevron-left"/></a>
      </div>-->
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex"
import wNumb from "wnumb"
var mformat = wNumb({
  decimals: 0,
  thousand: ",",
  prefix: "£"
})

export default {
  computed: {
    ...mapState(["latest"])
  },
  methods: {
    formatPrice(val) {
      if (typeof val == "number") return mformat.to(val)
      else return mformat.to(Number(val))
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.latest {
  padding: 6rem 0;
  text-align: center;
  background: #d1ae54;
}

.header {
  font-size: 4rem;
  margin-bottom: 4rem;
  text-align: center;
  color: #455c6e;
}

.grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  overflow: hidden;
  transition: all 0.2s;
  grid-gap: 3rem;
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .grid {
    display: table;
    width: 100%;
  }
  .grid > * {
    width: 23%;
    float: left;
    margin-right: 2%;
  }
}

.info {
  padding: 1rem 2rem;
  display: block;
}

.image {
  height: 30rem;
  display: block;
  background-size: cover;
  background-position: center center;
  transition: all 0.2s;
}

.latest a:nth-child(3) .image {
  background-image: url(../assets/house3.jpg);
}

.latest a:nth-child(2) .image {
  background-image: url(../assets/house2.jpg);
}

.latest a:nth-child(4) .image {
  background-image: url(../assets/house4.jpg);
}

.grid a {
  transition: all 0.2s;
  padding-bottom: 1rem;
  background: white;
  border-bottom: 0.5rem solid #253e52;
}

.grid a:hover .image {
  filter: brightness(1.05);
}

.name {
  display: block;
  font-size: 2rem;
  font-weight: bold;
  margin-top: 0.5rem;
  color: #253e52;
}

.slide {
  width: 100%;
}

.date {
  display: block;
  font-size: 1.5rem;
  color: #d1ae54;
  font-weight: bold;
}

.controls {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  pointer-events: none;
  z-index: 3;
}

.next {
  float: right;
  transform: translateX(50%);
}

.prev {
  transform: translateX(-50%);
}

.controls a {
  pointer-events: all;
  position: relative;
  border: 2px solid #272425;
  display: block;
  width: 5rem;
  height: 5rem;
  background: white;
  border-radius: 100%;
  line-height: 4.8rem;
  text-align: center;
  font-size: 2rem;
  transition: all 0.2s;
}

.controls a:hover {
  color: #a39064;
  border: 2px solid #a39064;
}

@media screen and (max-width: 750px) {
  .grid {
    grid-template-columns: 1fr;
  }

  .controls {
    display: none;
  }

  .next {
    transform: none;
  }

  .prev {
    transform: none;
  }
}

@media screen and (max-width: 500px) {
  .header {
    font-size: 3rem;
  }
}
</style>
